import React from 'react';
import styles from './Phone.module.css';

const Phone = () => {
  return (
    <div className={styles.phone}>
      <img src="/phone-green.png" alt="Phone with App" />
    </div>
  );
};

export default Phone;